import {
  sendMsg,
  ENDPOINT_REQUEST as userServicesRequest,
  SERVICES_REQUEST as services,
} from '../../configurations';
import { PARAMS as requestParams } from '@/constants/params';

export const accountServices = {
  getPortfolioService,
  getTransactionHistoryService,
  getTradingAccount,
  switchTradingAccount,
  getAccountBalance,
  setDefaultTradingAccount,
  getAssetAllocation,
  getAvailableQuantityService,
  getAAStockService,
  getAccountBankBalanceService,
  getStatementListService,
  getStatementContentService,
  EnquiryBuyingPowerService,
  queryAccountDetailsService,
  createTradingAccService,
}

// Call services to get Trading Account
function getTradingAccount(params, callback) {
  sendMsg(services.AUTH, userServicesRequest.iTRADE.GET_TRADING_ACCOUNT, params).get(res => {
    callback(res);
  })
}

// Call services to get Trading Account
function switchTradingAccount(params, callback) {
  sendMsg(services.AUTH, userServicesRequest.iTRADE.SWITCH_TRADING_ACCOUNT, params).post(res => {
    callback(res);
  })
}

// Call services to get Account Balance
function getAccountBalance(params, callback) {
  sendMsg(services.EQT, userServicesRequest.iTRADE.CLIENT.GET_ACCOUNT_BALANCE.format(params[requestParams.CLIENT_ID]), params).get(res => {
    callback(res)
  })
}

// Call services to get Portfolio Data
function getPortfolioService(params, callback) {
  sendMsg(services.EQT, userServicesRequest.iTRADE.CLIENT.GET_PORTFOLIOS.format(params[requestParams.CLIENT_ID]), params).get(callback)
}

// Call services to get Transaction History Data
function getTransactionHistoryService(params, callback) {
  sendMsg(services.EQT, userServicesRequest.iTRADE.CLIENT.GET_TRANSACTION_HISITORY.format(params[requestParams.CLIENT_ID]), params).get(res => {
    callback(res)
  })
}

// Call services to set default Trading Account
function setDefaultTradingAccount(params, callback) {
  sendMsg(services.AUTH, userServicesRequest.iTRADE.SET_DEFAULT_TRADING_ACCOUNT, params).post(res => {
    callback(res);
  })
}

// Call services to get Asset Allocation
function getAssetAllocation(params, callback) {
  sendMsg(services.EQT, userServicesRequest.iTRADE.CLIENT.GET_ACCOUNT_BALANCE.format(params.clientID), params).get(res => {
    callback(res);
  })
}

// Call services to get available quantity
function getAvailableQuantityService(params, callback) {
  sendMsg(services.EQT, userServicesRequest.iTRADE.CLIENT.GET_AVAILABLE_QUANTITY.format(params.clientID), params).get(res => {
    callback(res);
  })
}

// Call services to get AAStock
function getAAStockService(params, callback) {
  sendMsg(services.COMMON_QUOTE, userServicesRequest.iTRADE.AAStock.AA_STOCK, params).get(res => {
    callback(res);
  })
}

// Call services to get Account Bank Balance
function getAccountBankBalanceService(params, callback) {
  sendMsg(services.EQT, userServicesRequest.iTRADE.CLIENT.GET_BANK_BALANCE.format(params.clientID), params).get(res => {
    callback(res);
  })
}

// Call services to get Statement List
function getStatementListService(params, callback) {
  sendMsg(services.EQT, userServicesRequest.iTRADE.CLIENT.GET_STATEMENT_LIST.format(params.clientID), params).get(res => {
    callback(res);
  })
}

// Call services to get Statement Content
function getStatementContentService(params, callback) {
  sendMsg(services.EQT, userServicesRequest.iTRADE.CLIENT.GET_STATEMENT_CONTENT.format(params.clientID), params).get(res => {
    callback(res);
  })
}

// Call services to Enquiry BuyingPower
function EnquiryBuyingPowerService(params, callback) {
  sendMsg(services.EQT, userServicesRequest.iTRADE.CLIENT.ENQUIRY_BUYING_POWER.format(params.clientID), params).get(res => {
    callback(res);
  })
}

// Call services to query Account Details
function queryAccountDetailsService(params, callback) {
  sendMsg(services.EQT, userServicesRequest.iTRADE.CLIENT.QUREY_ACCOUNT_DETAILS, params).get(res => {
    callback(res);
  })
}

// Call services to create or update Trading Account
function createTradingAccService(params, callback) {
  sendMsg(services.EQT, userServicesRequest.iTRADE.CLIENT.CREATE_TRADING_ACC, params).post(res => {
    callback(res);
  })
}